export enum ExtractionStatus {
  PENDING = "pending",
  FAILED = "failed",
}
